import React from 'react';
import { faStethoscope, faHeart, faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Footer(): React.ReactElement {
  const currentYear = new Date().getFullYear();
  const { currentOrganization } = useAuth();
  const location = useLocation();
  const isAdminContext = location.pathname.startsWith('/admin');

  return (
    <footer className="bg-white border-t border-gray-200 h-16 flex">
      <div className="px-4 py-4 flex-1 flex">
        <div className="flex flex-col flex-grow md:flex-row justify-between items-center space-y-2 md:space-y-0">
          {/* Left side - Organization/Admin info */}
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <div
              className={`flex items-center justify-center w-6 h-6 rounded ${
                isAdminContext ? 'bg-red-600' : 'bg-blue-600'
              }`}
            >
              <FontAwesomeIcon
                icon={isAdminContext ? faCog : faStethoscope}
                className="w-3 h-3 text-white"
              />
            </div>
            <span>
              © {currentYear}{' '}
              {isAdminContext
                ? 'OptoSoft - Administração SaaS'
                : `${currentOrganization?.name || 'OptoSoft'} ${currentOrganization?.slogan || ''}`}
            </span>
          </div>

          {/* Right side - Developer attribution */}
          <div className="flex items-center space-x-1 text-sm text-gray-500">
            <span>Desenvolvido com</span>
            <FontAwesomeIcon icon={faHeart} className="w-3 h-3 text-red-500" />
            <span>por</span>
            <a
              href="https://um0um.com.br"
              target="_blank"
              rel="noreferrer"
              className="font-medium text-blue-600 hover:text-blue-700 transition-colors"
            >
              101 Soluções
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}